import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {EnvironmentConfigService} from '../../core/config/environment-config.service';
import {firstValueFrom} from 'rxjs';
import {Router} from '@angular/router';
import {PlanType, PlansTemplateComponent} from '../plans-template/plans-template.component';
import {TrialTemplateComponent} from '../trial-template/trial-template.component';
import {WhyChooseTemplateComponent} from '../why-choose-template/why-choose-template.component';

@Component({
  selector: 'app-subscriptions',
  imports: [
    PlansTemplateComponent,
    TrialTemplateComponent,
    WhyChooseTemplateComponent
  ],
  templateUrl: './subscriptions.component.html',
  styleUrl: './subscriptions.component.css'
})
export class SubscriptionsComponent implements OnInit {
  private stripePublicKey: string = '';
  private stripeMonthlyPriceId: string = '';
  private stripeAnnualPriceId: string = '';

  private apiBaseUrl: string = '';

  // Loading state
  public isLoading = false;

  constructor(
    private environmentConfigService: EnvironmentConfigService,
    private httpClient: HttpClient,
    private authService: AuthenticationService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.stripePublicKey = this.environmentConfigService.StripePublicKey;
    this.stripeMonthlyPriceId = this.environmentConfigService.StripeMonthlyPriceId;
    this.stripeAnnualPriceId = this.environmentConfigService.StripeAnnualPriceId;
    this.apiBaseUrl = this.environmentConfigService.apiUrl;
  }

  async onPlanSelected(planType: PlanType): Promise<void> {
    await this.redirectToCheckout(planType);
  }

  async onTrialSelected(): Promise<void> {
    const currentUser = await this.authService.getCurrentUser();
    if (currentUser) {
      await this.router.navigate(['/busca']);
      return;
    }
    await this.router.navigate(['/criar-conta']);
  }

  async redirectToCheckout(planType: 'monthly' | 'annual'): Promise<void> {
    try {
      this.isLoading = true;

      // Determine which price ID to use based on the selected plan
      const priceId = planType === 'monthly'
        ? this.stripeMonthlyPriceId
        : this.stripeAnnualPriceId;

      // Prepare data for the backend call
      const checkoutData = {
        priceId: priceId,
        successUrl: `${window.location.origin}/assinatura-concluida`,
        cancelUrl: `${window.location.origin}/planos`,
      };

      // Create headers with the authorization token if the user is authenticated
      let headers = new HttpHeaders()
        .set('content-type', 'application/json');

      const idToken = await this.authService.getIdToken();
      const endpoint = idToken ? `${this.apiBaseUrl}/stripe/checkout` : `${this.apiBaseUrl}/stripe/checkout-unauthenticated`;

      if (idToken) {
        headers = headers.set('Authorization', idToken);
      }

      // Make a POST request to the backend endpoint with the authorization header
      const response = await firstValueFrom(
        this.httpClient.post<any>(
          endpoint,
          checkoutData,
          { headers, observe: 'response' as const }
        )
      );

      console.log('response', response);

      // If 201, redirect to Stripe using the returned URL or Location header
      if (response.status === 201) {
        const url = response.body?.url;
        if (url) {
          window.location.href = url;
          return;
        }
        console.log(response);
        throw new Error('201 without URL');
      }


      throw new Error('Invalid response from server');
    } catch (error) {
      console.error('Error in redirectToCheckout:', error);
      alert('Ocorreu um erro ao processar sua assinatura. Tente novamente mais tarde.');
    } finally {
      this.isLoading = false;
    }
  }

}
